import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

/** A saved external API key (Settings → API Keys) reused in journey API steps. */
export interface CompanyApiKey {
  id: string;
  name: string;
  apiKey: string;
  createdAt?: string;
}

@Injectable({ providedIn: 'root' })
export class ApiKeyStoreService {
  constructor(private api: ApiService) {}

  list() {
    return this.api.get<CompanyApiKey[]>('/api/api-keys');
  }

  create(name: string, apiKey: string) {
    return this.api.post<CompanyApiKey>('/api/api-keys', { name, apiKey });
  }

  delete(id: string) {
    return this.api.delete<void>('/api/api-keys/' + id);
  }
}
